// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5ede1cea","453":"6aaf6812","455":"9b943a8c","977":"cf9c049f"}[chunkId] + ".chunk.js";
};